<app-loading class="dashboard-loading" [size]=".5" *ngIf="(!(isAppointmentsLoading$ | async)); else dashboard"
color="var(--primary-sec-color)"></app-loading>
<ng-template #dashboard>
  <div>
    <div class="customer-details m-3">
      <div class="cust-name">
        <span>{{ getCustomerDisplayName((currentCustomer$ | async)) }}</span>
      </div>
      <div class="cust-info row">
        <div class="col-10 pt-1">
          <span>
            <span *ngIf="(currentCustomer$ | async).phoneNumber && !(currentCustomer$ | async).drvaFlag">{{((currentCustomer$ | async).phoneNumber | phone)}}</span>
          <span *ngIf="(currentCustomer$ | async).phoneNumber && (currentCustomer$ | async).emailAddress && !(currentCustomer$ | async).drvaFlag">{{' | ' }}</span>
          <span *ngIf="(currentCustomer$ | async).emailAddress && !(currentCustomer$ | async).drvaFlag">{{(currentCustomer$ | async).emailAddress }}</span>
          </span>
          <app-do-not-modify-banner *ngIf="(currentCustomer$ | async).drvaFlag"></app-do-not-modify-banner>          
        </div>
        <div class="col new-appointment-btn">
          <span [class.disabled]="isButtonDisable()" *ngIf="!isNotServiceAccessible()">
            <asp-info-button [name]="getNewAppointmentTxt()" type='small' (click)="onNewAppointmentClick()"></asp-info-button>
          </span>
        </div>
      </div>
    </div>
    <app-splitter class="app-splitter d-block mx-3" [config]="'horizontal 100% 0 .4rem'"></app-splitter>
    
    <div>
      <div class="dashboard-container col-md-auto">
        <app-appointment-section [appointmentType]="default"></app-appointment-section>
        <app-splitter class="app-splitter d-block mx-3" [config]="'horizontal 100% 0 .4rem'"></app-splitter>
        <app-appointment-section [appointmentType]="allApptTypes"></app-appointment-section>
      </div>
    </div>
  </div>
</ng-template>
